import { useState } from "react";
import { Copy, Check, Landmark } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { useSettings } from "@/context/SettingsContext";

const CopyBtn = ({ value, testId }) => {
  const { t } = useLang();
  const [ok, setOk] = useState(false);
  const copy = async () => {
    await navigator.clipboard?.writeText(value).catch(() => {});
    setOk(true);
    setTimeout(() => setOk(false), 1500);
  };
  return (
    <button type="button" onClick={copy} data-testid={testId} className="inline-flex items-center gap-1 rounded-full border border-border px-3 py-1 text-xs font-semibold hover:bg-muted">
      {ok ? <Check className="h-3.5 w-3.5 text-primary" /> : <Copy className="h-3.5 w-3.5" />}{ok ? t("copied") : t("copy")}
    </button>
  );
};

export const BankDetails = ({ amount }) => {
  const { t, tr } = useLang();
  const { settings } = useSettings();
  const accounts = settings?.bank_accounts || [];
  return (
    <div className="space-y-4" data-testid="dashboard-bank-details">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <h2 className="flex items-center gap-2 text-lg font-bold"><Landmark className="h-5 w-5 text-primary" />{t("pay_title")}</h2>
        {amount && (
          <div className="text-right">
            <p className="text-xs font-semibold uppercase tracking-widest text-muted-foreground">{t("amount_due")}</p>
            <p className="text-2xl font-extrabold text-primary" data-testid="dashboard-amount-due">{amount}</p>
          </div>
        )}
      </div>
      {tr(settings?.payment_instructions) && <p className="whitespace-pre-line text-sm text-muted-foreground" data-testid="dashboard-payment-instructions">{tr(settings.payment_instructions)}</p>}
      <div className="grid gap-3 sm:grid-cols-2">
        {accounts.map((a, i) => (
          <div key={a.id || i} className="rounded-2xl border border-border bg-muted/40 p-4" data-testid={`bank-account-${i}`}>
            <p className="text-sm font-bold">{a.bank_name}</p>
            <p className="text-xs text-muted-foreground">{t("account_name")}: <span className="font-semibold text-foreground">{a.account_name}</span></p>
            <div className="mt-3 flex items-center justify-between gap-2">
              <span className="break-all font-mono text-lg font-bold tracking-wider" data-testid={`bank-account-number-${i}`}>{a.account_number}</span>
              <CopyBtn value={a.account_number} testId={`bank-account-copy-${i}`} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
